module.exports = __webpack_public_path__ + "img/05-oval-not-convex-2.33b7e5f9.svg";